export default "__VITE_ASSET__BVE9EBmX__"